// Horizontal scroll-snap slider: prev/next buttons step by one card width.
// A button with nowhere left to go gets .is-disabled and aria-disabled, so the
// Designer's .is-disabled combo on the button shows the start and the end.
// A [data-slider-fit] root also sets --slider-fit-h on its track to the height
// of the card at the snap edge; the track's height and its transition are the
// Designer's, so the content below follows the card it is showing.
import { onReady } from '../utils/ready.js';

export function initSlider() {
  onReady(function () {
    document.querySelectorAll('[data-slider]').forEach(function (root) {
      var track = root.querySelector('[data-slider-track]');
      var prev = root.querySelector('[data-slider-prev]');
      var next = root.querySelector('[data-slider-next]');
      if (!track || !prev || !next) return;
      var fit = root.hasAttribute('data-slider-fit');
      function cards() {
        var list = track.querySelectorAll('[data-slider-card]');
        return list.length ? Array.prototype.slice.call(list) : Array.prototype.slice.call(track.children);
      }
      function step() {
        var card = cards()[0];
        if (!card) return 0;
        var cs = getComputedStyle(track);
        return card.getBoundingClientRect().width + (parseFloat(cs.columnGap) || 0);
      }
      function mark(button, off) {
        button.classList.toggle('is-disabled', off);
        if (off) button.setAttribute('aria-disabled', 'true');
        else button.removeAttribute('aria-disabled');
      }
      function height() {
        var list = cards();
        var size = step();
        if (!list.length || !size) return;
        var card = list[Math.min(list.length - 1, Math.round(track.scrollLeft / size))];
        track.style.setProperty('--slider-fit-h', card.offsetHeight + 'px');
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        mark(prev, track.scrollLeft <= 1);
        mark(next, track.scrollLeft >= max - 1);
        if (fit) height();
      }
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      if (fit && window.ResizeObserver) {
        var watch = new ResizeObserver(update);
        cards().forEach(function (card) {
          watch.observe(card);
        });
      }
      update();
    });
  });
}
